import type { PlatformStore } from './types';
import { webStorage } from './webStorage';

/** Returns the browser platform store (always available). */
export function getPlatformStore(): PlatformStore {
  return webStorage;
}

/** Open URL in a new browser tab (Garmin OAuth, external links). */
export function openExternal(url: string): void {
  window.open(url, '_blank', 'noopener,noreferrer');
}

/** Base URL of this web app (Garmin OAuth return). */
export function getWebAppBaseUrl(): string {
  const envUrl =
    (import.meta.env.VITE_PWA_URL as string | undefined) ||
    (import.meta.env.VITE_WEB_APP_URL as string | undefined);
  if (envUrl) return envUrl.replace(/\/$/, '');
  if (typeof window !== 'undefined') return window.location.origin;
  return 'http://127.0.0.1:3002';
}
